import { createRoot } from '@wordpress/element';
import { Provider } from 'react-redux';

import Store from './store/Store';
import App from './App';

import './scss/app.scss';

const rootElement = document.getElementById('wooArchiveRoot');
const root = createRoot(rootElement);

root.render(
    <Provider store={Store}>
        <App />
    </Provider>
);
